import { render, staticRenderFns } from "./ClienteForm.vue?vue&type=template&id=b63b897c"
import script from "./ClienteForm.vue?vue&type=script&lang=js"
export * from "./ClienteForm.vue?vue&type=script&lang=js"
import style0 from "./ClienteForm.vue?vue&type=style&index=0&id=b63b897c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports